import React from 'react';

interface Props {
   sample: string;
}

const Apps = () => {
   return <div>Apps</div>;
};

export default Apps;
